import React, { useState } from 'react';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import Section from '../components/Section';
import './Give.css';

const givingTypes = [
    {
        id: 'tithes',
        title: 'Tithes',
        description: 'The tithe is a scriptural principle of returning the first tenth of our increase to God. It is an act of worship and obedience, acknowledging God as our provider and sustainer.'
    },
    {
        id: 'offerings',
        title: 'Offerings',
        description: 'Offerings are freewill gifts given above and beyond the tithe. Your generous offerings allow us to expand our reach, enhance our worship experience, and bless our community in tangible ways.'
    },
    {
        id: 'projects',
        title: 'Projects',
        description: 'We believe in building a lasting legacy for future generations. Giving towards Projects supports church infrastructure, building expansion, and special equipment needs that empower our mission.'
    },
    {
        id: 'compassion',
        title: 'Compassion',
        description: 'Through our Compassion fund and Village of Hope (VOH) partnership, we provide healthcare, education, and relief to those in need. Join us in being the hands and feet of Christ.'
    }
];

const Give = () => {
    const [activeTab, setActiveTab] = useState('tithes');
    const active = givingTypes.find(g => g.id === activeTab);

    return (
        <Layout>
            <SEO title="Give" description="Support the mission of PAOZ Hope Community Church through tithes, offerings, and projects." />
            <div className="page-hero" style={{ backgroundImage: 'url("/Images/heroo.jpg")' }}>
                <div className="container">
                    <h1 className="animate-fade-in-up">Generous Living</h1>
                    <p className="animate-fade-in-up delay-100 italic-quote">
                        "Each of you should give what you have decided in your heart to give,
                        not reluctantly or under compulsion, for God loves a cheerful giver."
                        <span className="quote-ref">— 2 Corinthians 9:7</span>
                    </p>
                </div>
            </div>

            <Section className="give-section">
                <div className="give-wrapper animate-fade-in-up">

                    {/* Tab Buttons */}
                    <div className="give-tabs">
                        {givingTypes.map(g => (
                            <button
                                key={g.id}
                                className={`give-tab ${activeTab === g.id ? 'active' : ''}`}
                                onClick={() => setActiveTab(g.id)}
                            >
                                {g.title}
                            </button>
                        ))}
                    </div>

                    {/* Active Description */}
                    <div className="give-desc-block">
                        <h2 className="premium-title">{active.title}</h2>
                        <p>{active.description}</p>
                        <p className="give-ref-hint">
                            When making payment, use reference: <strong>{active.title.toUpperCase()} &mdash; [Your Name]</strong>
                        </p>
                    </div>

                    {/* Shared Account Details */}
                    <div className="give-accounts-card">
                        <div className="give-accounts-title">Bank &amp; Payment Details</div>
                        <p className="give-note">
                            The same accounts apply for all giving types. Please include your giving category in your payment reference.
                        </p>

                        <div className="accounts-grid">
                            <div className="account-block">
                                <div className="account-block-header">Bank Details</div>
                                <div className="account-row">
                                    <span className="account-key">Bank</span>
                                    <span className="account-val">Stanbic Bank</span>
                                </div>
                                <div className="account-row">
                                    <span className="account-key">Branch</span>
                                    <span className="account-val">Westgate</span>
                                </div>
                                <div className="account-row">
                                    <span className="account-key">Account Name</span>
                                    <span className="account-val">PAOZ Hope Community Church</span>
                                </div>
                            </div>

                            <div className="account-block">
                                <div className="account-block-header">ZIG Accounts</div>
                                <div className="account-row">
                                    <span className="account-key">Main ZIG</span>
                                    <span className="account-val mono">9140002075937</span>
                                </div>
                                <div className="account-row">
                                    <span className="account-key">Projects ZIG</span>
                                    <span className="account-val mono">9140001186603</span>
                                </div>
                            </div>

                            <div className="account-block">
                                <div className="account-block-header">USD Account</div>
                                <div className="account-row">
                                    <span className="account-key">USD</span>
                                    <span className="account-val mono">9140001446249</span>
                                </div>
                            </div>

                            <div className="account-block ecocash-block">
                                <div className="account-block-header">EcoCash</div>
                                <div className="account-row">
                                    <span className="account-key">Short Code</span>
                                    <code className="ecocash-code">*151*2*2*45233*AMOUNT#</code>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </Section>
        </Layout>
    );
};

export default Give;
